import { LgpHeroQuery } from "../types";
import { ILgpHero } from '@sky-it-livedata/livedata-sports-design-system';
import { getDriverName } from '../utils';
import { RaceSessionType, Sport } from '../../../types/lgp';
import { isValidLgpHero } from './typeguards';
import { LgpHeroInfo, LgpHeroPodium, LgpHeroSession, CreateLgpHeroWidgetInputSchema } from "appsync";
import { WidgetError, ErrorName } from "../../../utils/errors";


export default (obj: LgpHeroQuery): ILgpHero => {
  if (isValidLgpHero(obj)) {
      CreateLgpHeroWidgetInputSchema().parse(obj.data.getLgpHeroWidget, {reportInput: true});
      const { info, session } = obj.data.getLgpHeroWidget;
      const { sportTag, flagImgUrl, customGpName, startDate, endDate, circuitImgUrl } = info as LgpHeroInfo;
      const { label, status, podium } = session as LgpHeroSession;

      return {
        sportTag: sportTag as Sport,
        flagImgUrl,
        customGpName,
        startDate,
        endDate,
        circuitImgUrl,
        sessionStatus: status,
        sessionName: label as RaceSessionType,
        podium: (podium as LgpHeroPodium[]).map((driver) => {
          const { customDriverSurname, customDriverName, customDriverShortName, driverImgUrl, position, flagImgUrl } =
            driver;
          return {
            customDriverName: getDriverName(customDriverSurname as string, customDriverName as string),
            customDriverShortName,
            flagImgUrl,
            driverImgUrl,
            position,
          };
        }),
      } as ILgpHero;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in LgpHeroQuery object',
      data: obj
    });
  }
};
